/**
 * =============================================================================
 * HOME PAGE - MISSION CONTROL
 * =============================================================================
 * 
 * Home page now renders the Mission Control dashboard layout.
 * 
 * LINKAGE:
 * 1. Import MissionControlLayout component
 * 2. Import HOME_PAGE_LAYOUT configuration
 * 3. Render inside AppLayout
 * 
 * CONFIGURATION:
 * - Layout structure: packages/frontend/src/components/MissionControl/layouts/layout.config.ts
 * - Widget components: packages/frontend/src/components/MissionControl/widgets/
 * - API services: packages/frontend/src/components/MissionControl/api/
 * 
 * TO REVERT TO OLD LAYOUT:
 * See git history for previous Home.tsx implementation
 */

import { Box } from '@mantine/core';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

// =============================================================================
// MISSION CONTROL IMPORTS
// =============================================================================
import { MissionControlLayout, HOME_PAGE_LAYOUT } from '@components/MissionControl';

// =============================================================================
// HOME PAGE COMPONENT
// =============================================================================
const Home: FC = () => {
    return (
        <AppLayout>
            <Box className="min-h-full w-full">
                {/* 
                 * MissionControlLayout renders the dashboard based on config.
                 * 
                 * HOME_PAGE_LAYOUT defines:
                 * - Header (greeting + title)
                 * - Metric Strip (20% height)
                 * - Watch Card Grid (40% width, 60% height)
                 * - Standalone Watch Card (40% width, 40% height)
                 * - Watchlist Widget (60% width, 100% height)
                 * 
                 * Edit layout.config.ts to change structure.
                 */}
                <MissionControlLayout config={HOME_PAGE_LAYOUT} />
            </Box>
        </AppLayout>
    );
};

export default Home;
